module.exports = __webpack_public_path__ + "assets/img/loader.a9842492.svg";